<template>
  <div>
        <public-title>找酒店</public-title>
        <template v-if="count>0||isSearch">
            <div class=" bg-white rounded-md">
                <div class="release">
                    <el-button type="primary" class="bottom" icon="el-icon-edit-outline" @click="releasePrice()">发布询价</el-button>
                </div>
                <div class="rounded-tetod">
                    条件搜索
                </div>
                <div class="category-wrap" >
                    <CitySelection  :infoLise="infoLise" @formData="handleFormData" :searcValue="formData"  mode="underline" :canChange="canChange" class="city-selection" ref="citySelectionRef"></CitySelection>
                </div>
                <!--城市选择-->
                <div class="search-wrap">
                    <el-autocomplete
                    class="inline-input"
                    v-model="BasicInfo.title"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="搜索酒店品牌或名称..."
                    :trigger-on-focus="false"
                    @select="handleSelect"
                    prefix-icon="el-icon-search"
                    >
                    <template slot-scope="{ item }">
                        <!-- v-html 必须用，渲染包裹的span标签 -->
                        <span v-html="$verify.highlightKeyword(item.title, BasicInfo.title)"></span>
                    </template>
                    </el-autocomplete>
                    <el-button type="primary" class="bottom" icon="el-icon-search" @click="loadList();isSearch=true">立即搜索</el-button>
                </div>
            </div>
            <!--找酒店列表-->
            <template v-if="!chartshow">
                <div v-if="list.length>0">
                    <ul class="findhotel-list">
                        <li v-for="item in list" :key="item.id" >
                            <img v-lazy="ImgPreUrl+item.hotel_top_pic"   class="img" :key="item.offer_uid" @click="viewDetails(item)">
                            <div class="information"  @click.stop="salesDetails(item)">
                                <div class="title">
                                    <h4>
                                        {{item.hotel_title}}
                                        <img v-lazy="'/images/zfxj/icon_'+item.state_star+'.png'" :key="item.state_star" height="16px" v-if="item.state_star>0" class="text-star"/>
                                        <img v-lazy="'/images/xj/icon_'+item.hotel_star+'.png'" :key="item.star" height="16px" v-else  class="text-star"/>
                                    </h4>
                                </div>
                                <div class="justify-content">
                                    <div class="one">
                                        <i class="iconfont icon-ruzhugongsi"></i>
                                        <span>总客房</span>
                                        <p>{{item.hotel_room_count}}间</p>
                                    </div>
                                    <div class="two" v-if="item.hotel_room_2_count>0">
                                        <i class="iconfont  icon-dachuang"></i>
                                        <span>双床房</span>
                                        <p>{{item.hotel_room_2_count}}间</p>
                                    </div>  
                                </div>
                                <div class="address">
                                    <div class="address-content">
                                        <i class="el-icon-location-information text-login mr-1"></i>
                                        <p>{{ parseAddress(item) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="price-box">
                                <p class="price">
                                    <span>¥</span>{{item.room_offer_arr.min_offer_price_str}}
                                </p>
                                <div class="button">
                                    <!-- <i class="iconfont icon-quxiantu"></i> -->
                                    <el-button  size="small " type="primary" @click.stop="salesDetails(item)">最新报价</el-button>
                                    <el-button  size="small " @click.stop="chart({data:{offer_store_id:item.offer_store_id},id:1,hotel_title:item.hotel_title})"><i class="iconfont icon-quxiantu" ></i>图表</el-button>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <!--分页-->
                    <el-pagination background layout="prev, pager, next" class="mt-4"
                        :page-size="formData.num"
                        :total="count" :current-page="Number(formData.page)"
                        @current-change="v => formData.page = v"/>
                </div>
                <!--drawer-->
                <div v-else>
                    <div class="itemcard">
                        <div class="no-search-result">
                        <img src="/images/order/icon_22.png"/>
                        <div class="no-search-text">
                            <p class="one">抱歉，没有搜索到相关结果。</p>
                            <p class="two">请更改筛选选项后重试</p>
                            <el-button type="primary" @click="clearSearch">清除选项</el-button>
                        </div>
                        </div>
                    </div>
                </div>
            </template>
            <!--酒店图表-->
            <div v-if="chartshow" class="chart-box">
                <div class="chart-title">
                    <h3>{{chartname}} 报价图表</h3>
                </div>
                <ul class="chart-series">
                    <li v-for="(item,index) in series" :key="index"  :class="{'active':currentRoomType==index}" @click="changeRoomType(index)">
                        {{item.name}}
                    </li>
                </ul>
                <div v-if="loading" class="loading-box">
                    <i class="el-icon-loading"></i>
                    <p>加载中~</p>
                </div>
                <LineChart :chartData="chartData" class="charts-box"></LineChart>
                <el-button  @click.stop="chartshow=false" class="charts-btn" :disabled="loading">返回列表</el-button>
            </div>
        </template>
        <!--没有历史报价信息-->
        <template v-if="count==0&&!isSearch">
            <div class="load-area flex-center">
                <img src="/images/order/icon_21.png"/>
                <p>暂无历史报价、请尝试发布询价</p>
                <el-button type="primary" class="bottom" icon="el-icon-edit-outline" @click="releasePrice()" style="width: 200px;">发布询价</el-button>
            </div>
        </template>
        <el-drawer
            class="drawer"
            :visible.sync="cliqueNumber"
            label="rtl"
            size="460px"
            :show-close="false"
            :before-close="handleClose"
            ref="drawerRef"
            >
            <div class="team-list">
                <div class="team-title">
                    <div>
                        <div class="team-title-tiem">{{currentCity.hotel_title}}</div>
                        <div class="team-title-name">报价销售</div>
                    </div>
                    <div class="dayDate-top-close" @click="cliqueNumber=false">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
                <!--报价销售列表-->
                <ul class="historyOfferSaleList">
                    <li v-for="item in historyOfferSaleList" :key="item.offer_uid" @click="handleClick(item)">
                        <img :src="item.offer_avatar?ImgPreUrl+item.offer_avatar:'/images/avatar/avatar_0.png'" class="img" :key="item.offer_uid"/>
                        <div class="offer_name">
                            <div class="name">{{item.offer_name}}</div>
                            <div class="phones" v-if="item.position_name">{{ item.position_name}}</div>
                            <!-- <div class="phone"><i class="iconfont icon-shoujihao"></i>{{item.offer_mobile}}</div> -->
                        </div>
                        <div class="position">
                            <div class="position_phone" @click.stop="handleCopy(item.offer_mobile)">
                                <i class="iconfont icon-shoujihao position_mobile"></i>
                            </div>
                            <div class="position_phone">
                                <i class="iconfont icon-yanjing- position_mobile check"></i>
                            </div>
                        </div>
                    </li>
                </ul>
                <QuoteHistory :sales="sales" :innerDrawer="innerDrawer" @close="innerDrawer=false" @openCtripDetail="chart"></QuoteHistory>
            </div>
        </el-drawer>
        <!--销售查看图表数据弹出框-->
        <el-dialog
        :title="`${chartname} 报价图表`"
        :visible.sync="chartshow2"
        width="1200px"
        >
        <ul class="chart-series">
            <li v-for="(item,index) in series" :key="index"  :class="{'active':currentRoomType==index}" @click="changeRoomType(index)">
                {{item.name}}
            </li>
        </ul>
        <div v-if="loading" class="loading-box">
            <i class="el-icon-loading"></i>
            <p>加载中~</p>
        </div>
        <LineChart :chartData="chartData" class="charts-box"></LineChart>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="chartshow2 = false">确 定</el-button>
        </span>
        </el-dialog>
  </div>    
</template>

<script>
  import CitySelection from '@/views/HomePage/IndexComps/IndexPage/Components/CitySelection.vue'
  import {mapState, mapGetters, mapActions} from 'vuex'
  import provinces from '@/assets/utils/provinces'             //省份信息
  import QuoteHistory from './components/QuoteHistory.vue'
  import LineChart from './components/line.vue'
  import dayjs from 'dayjs'
export default {
    name: '',
    components: {
        QuoteHistory,
        CitySelection,
        LineChart
    },
  props: {},
  data() {
    return {
        formData:{
            page:1,
            num:15,
            city:'',
            id:'',
        },
        list:[],                                    //酒店列表
        count:-1,                                   //总条数
        cliqueNumber:false,                         //抽屉是否显示
        currentCity:{},                             //当前酒店
        historyOfferSaleList:[],                    //报价销售列表
        innerDrawer:false,                          //报价销售详情抽屉是否显示
        sales:{},                                   //当前报价销售详情
        BasicInfo:{                                 //搜索酒店品牌或名称
            title:'',
        },                       
        defaultIndex: 0,
        infoLise:{},
        canChange:true,
        isSearch:false,                             //是否是搜索无酒店 
        //切换图表数据
        series:[],                          //图表数据
        chartshow:false,                            //图表是否显示
        chartname:'',                               //图表酒店
        chartid:'',                                 //图表ID
        chartData:{},
        //销售图标数据
        chartshow2:false,                          //销售图标数据开关
        //加载中
        loading:false,
        //当前房型
        currentRoomType:0,
        
    };
  },
  computed: {},
  watch: {
    'formData.page':{
        handler(newVal,oldVal){
            this.loadList()
        },
    }
  },
  created() {
    this.loadList();
    this.getHotCity();
  },
  mounted() {},
  methods: {
    ...mapActions(['POST_HistoryOfferHotel','POST_HistoryOfferHotelSale','POST_SearchDocHotel','POST_GetAllCity','POST_HistoryOfferHotelOfferList']),
    loadList(){
        this.chartshow=false;  //图表是否显示
        this.POST_HistoryOfferHotel({
            data:{
                ...this.formData,
                ...this.BasicInfo,
            },
            successFun:(res)=>{
                // 1. 提取全部offer
                const newList = res.list.map(item => {
                    // 获取当前这一条里offer_info的最低价格
                    item.room_offer_arr.list.forEach(offerItem => {
                        let prices=[]
                        if(item.room_offer_arr.mode==1){
                            prices = offerItem.offer_info.map(o => o.offer_price);
                        }else{
                            prices =  item.room_offer_arr.list.map(o => o.offer_price);
                        }
                        const minPrice = Math.min(...prices); 
                    // 新增字符串字段，存最低价格（转为string）
                    item.room_offer_arr.min_offer_price_str = String(minPrice)
                    })
                    return item
                })
                this.list=newList;
                this.count=res.count;
            }
        })
    },
    salesDetails(item){
        this.currentCity=item;
        this.cliqueNumber=true
        this.POST_HistoryOfferHotelSale({
            data:{
                offer_store_id:item.offer_store_id,
            },
            successFun:(res)=>{
                this.historyOfferSaleList=res.list
            }
        })
    },
    //关闭抽屉
    handleClose(done) {
        this.$confirm('确认关闭当前销售列表？')
          .then(_ => {
            this.cliqueNumber=false
          })
    },
    //获取本地地址信息
    parseAddress(res){
        let city = provinces.find(item => item.id == res.hotel_city);
        let district = provinces.find(item => item.id == res.hotel_district);
        return `${city.title}${district.title||''}${res.hotel_address}`;
    },
    handleCopy(text){
      // 创建临时input
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制销售电话成功')
    },
    handleClick(item){
        this.sales=item
        this.innerDrawer=true
    },
    //点击搜索框的建议项-跳转详情
    handleSelect(item) {
      this.BasicInfo.title=item.title;
    },
    //搜索框的建议列表
    async querySearchAsync(queryString, cb) {
      //内容不等于空字符串
      if (queryString.trim() === '') {
        cb([]);
        return;
      };
      let res= await this.POST_SearchDocHotel({data:{title: queryString,city:this.formData.city}});
      this.timeout = setTimeout(() => {
        cb(res.list);
      }, 2000 * Math.random());
    },
    OpenFilter(index){
        this.defaultIndex!=index?this.defaultIndex=index:this.defaultIndex=0
    },
    //获取热门城市列表
    async getHotCity(){
        let res = await this.POST_GetAllCity({});
        this.infoLise = res;
    },
    //搜索信息
    handleFormData(formData){
        this.formData.city=formData.cityId;
    },
    //清楚选项
    clearSearch(){
        this.BasicInfo.title='';
        //调用子级组件的方法，清空城市选择
        this.$refs.citySelectionRef.clearCity();
        this.loadList();
    },
    //跳转发布询价
    releasePrice(){
        this.$router.push({name:'OrderPost'})
    },
    //查看详情
    viewDetails(item){
        let changeRoute = this.$router.resolve('/index_hotel/hotel_detail/' + item.offer_store_id);
        window.open(changeRoute.href, '_blank');
    },
    //获取历史报价图表
    async chart(item){
        if(item.id==1){
            this.chartshow=true;
        }else{
            this.chartshow2=true;
        }
        if(item.hotel_title===this.chartname&&item.id===this.chartid){
            return;
        }
        this.loading=true;
        this.chartData={};
        this.chartid=item.id;
        this.chartname=item.hotel_title;
        await this.POST_HistoryOfferHotelOfferList({
            data:item.data,
            successFun:(res)=>{
                this.buildChartData(res.list);
                this.loading=false;
            }
        });
        // this.historyOfferHotelOfferList = res.list;
    },
    buildChartData(list) {
    const flatArr = []
    // 扁平化逻辑不变
    list.forEach(hotel => {
        hotel.room_offer_arr.list.forEach(dayItem => {
        const { date } = dayItem
        if(hotel.room_offer_arr.mode==1){
            dayItem.offer_info.forEach(info => {
            flatArr.push({
                date,
                offer_title: info.offer_title,
                offer_price: info.offer_price
            })
            })
        }else{
            hotel.room_offer_arr.list.forEach(roomItem => {
            flatArr.push({
                date:hotel.offer_time,
                offer_title: roomItem.offer_title,
                offer_price: roomItem.offer_price
            })
            })
        }
        })
    })

    // 按offer_title分组，每个分组只存自己有数据的【时间、价格】
    const groupMap = {}
    flatArr.forEach(item => {
        const title = item.offer_title
        const formatDate = dayjs(item.date * 1000).format('YYYY-MM-DD')
        if (!groupMap[title]) {
        groupMap[title] = {
            time: [],
            data: []
        }
        }
        groupMap[title].time.push(formatDate)
        groupMap[title].data.push(item.offer_price)
    })

    // 组装series
    const series = Object.entries(groupMap).map(([name, val]) => ({
        name,
        time: val.time,
        data: val.data
    }))
    this.series=series;
    this.changeRoomType(0);
    console.log(series)
    // this.chartData = JSON.parse(JSON.stringify({
    //     series
    // }))
    // console.log(series)
    },
    //切换房型
    changeRoomType(index){
        this.currentRoomType=index;
        this.chartData = JSON.parse(JSON.stringify({
            categories: this.series[index].time,
            series: [this.series[index]]
        }))
        
    }
}
}
</script>

<style lang="scss" scoped>
    .findhotel-list{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    .findhotel-list li{
        width: 32%;
        background-color: #fff;
        margin-top: 30px;
        border-radius: 8px;
        text-align:left;
        display: flex;
        overflow: hidden;
        cursor: pointer;
        margin-right: 2%;

    }
    .findhotel-list li:nth-child(3n){
        margin-right: 0;
    }
    //最后一个元素
    .findhotel-list li:last-child {
        margin-right: auto;
    }
    .findhotel-list .img{
        width: 230px;
        height: 170px;
        border-radius: 8px;
        overflow: hidden;
    }
    .information{
        margin-left: 16px;
        margin-top: 16px;
    }
    .title{
        font-size: 16px;
        height: 46px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h2{
            font-size: 20px;
        }
    }
    .text-star {
        display: inline-block;
        vertical-align: middle;
        margin-left: 2px;
        margin-top: -4px;
    }
    
    .justify-content{
        margin-top: 12px;
        display: flex;
        div{
        background-color: #f9fafb ;
        width: 100px;
        padding: 0 10px;
        display: flex;
        margin-right: 12px;
        border-radius: 6px;
        font-size: 12px;
        line-height: 34px;
        color: #4a5565;
        margin-bottom: 10px;
        i{
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin-right: 4px;
            color: #99a1af;
            font-size: 15px;
        }
        }
    }
    .information{
        width: 67%;
    }
    .justify-content .one p{  
        font-weight: bold;
        color: #333;
        margin-left: 4px;
        margin-left: auto;
    }

    .justify-content .two p{
        font-weight: bold;
        color: #333;
        margin-left: 4px;
        margin-left: auto;
     }
     .price-box{
        width: 170px;
        text-align: center;
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        padding: 16px;
     }
     .price{
        font-size: 24px;
        font-weight: bold;
        color: var(--smtc-color-text-red);
        text-align: right;
     }
     .price span{
        font-size: 16px;
     }
     .button{
        margin-top: 6px;
        display: flex;
     }
    .team-list{
        width: 100%;
        margin: 0 auto;
        position: relative;
        background-color: var(--smtc-color-back);
        height: 100%;   
    }
    .team-title{
        text-align: left;
        display: flex;
        justify-content: space-between;
        width: 94%;
        background-color: #fff;
        padding: 0 3%;
        padding-bottom: 10px;
        margin: 0 auto;
    }
    .team-title-tiem{
        color: #999;
    }
    .team-title-name{
        font-weight: bold;
        font-size: 18px;
    }
    .historyOfferSaleList{
        width: 94%;
        margin: 0 auto;
         li{
            width: 100%;
            border-radius: 8px;
             margin-top: 20px;
            display: flex;
            padding: 12px 4%;
            border: 1px solid #eee;
            box-shadow: 0px 0px 7px #eee;
            box-sizing: border-box;
            overflow: hidden;
            cursor: pointer;
            background-color: #fff;
         }
        img{
            width: 65px;
            height: 65px;
            border-radius: 50px;
            overflow: hidden;
           
        }
    }
    .offer_name{
        text-align: left;
        margin-left: 16px;
        height: 65px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .phone{
            margin-top: 6px;
            color: #999;
        }
    }
    .list-icon{
        margin-left: auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        color: #999;
    }
    .icon-shoujihao{
        margin-right: 2px;
        font-size: 13px;
    }
    .address{
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 40px;
    }
    .address-content{
        display: flex;
        align-items: center;
    }
    .address-content p{
        width: 80%;
        overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;
        font-size: 12px;
        color: #999;
    }
    @media (max-width:1801px){
        .findhotel-list li{
            width: 46%;
        }
    }
    .phones{
        font-weight: normal;
        margin-top: 12px;
        background-color: #fdf0e4;
        font-size: 11px;
        margin-top: 6px;
        padding: 4px 6px;
        border-radius: 4px;
        color: #ab753e;
    }
    .position_phone{
        margin-left: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 10px;
    }
    .position_mobile{
        background-color: #edf5fe;
        width: 40px;
        height: 40px;
        border-radius: 50px;
        text-align: center;
        line-height: 40px;
        color:var(--smtc-color-primary);
        font-size: 16px;

    }
    .check{
        background-color: #ebfbf0;
        color: #12bb47;
    }
    .position{
        margin-left: auto;
        display: flex;
    }
    .dayDate-top-close{
        background-color: var(--smtc-color-back) ;
        width: 30px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        border-radius: 50px;
        color: #666;
        font-size: 16px;
    }
    .rounded-md{
        display: flex;
        padding: 14px;
    }
    .category-wrap{
        border:1px solid #DCDFE6;
        height: 38px;
        border-radius: 4px;

    }
    .city-selection{
        margin-top : -12px;
    }
    .search-wrap{
        width: 750px;
        display: flex;
        justify-content:flex-end;
    }
    .inline-input{
        width: 80%;
        margin-right: 10px;
    }
    .rounded-tetod{
        line-height: 38px;
        margin-right: 10px;
        font-size: 14px;
        font-weight: bold;
    }
    .no-search-result{
        width: 100%;
        background-color: #fff;
        box-shadow: 0px 0px 7px #eee;
        border-radius: 16px;
        display: flex;
        justify-content: center;
        padding: 52px 0;
        margin-top: 20px;
        img{
        width: 120px;
        }  
    }
    .no-search-text{
        margin-left: 14px;
        text-align: left;
        .one{
        font-weight: bold;
        font-size: 16px;
        }
        .two{
        color: #666;
        margin: 6px 0;
        }
    }
  .img-info{
    display: flex;
    img{
      margin-top: 4px;
      margin-right: 8px;
    }
  }
  .release{
    margin-right: auto;
  }
  .flex-center{
    img{
        margin-top:140px;
    }
    p{
        font-size: 14px;
        color: #666;
        padding: 12px 0;
    }
  }
  .icon-quxiantu{
    font-size: 12px;
    margin-right: 2px;
  }
  .chart-box{
    width: 98%;
    padding: 12px 1%;
    background-color: #fff;
    box-shadow: 0px 0px 7px #eee;
    border-radius: 6px;
    margin-top: 20px;
  }
  .chart-title{
    text-align: left;
  }
  .charts-box{
    margin-top: 20px;
  }
  .charts-btn{
    margin-top: 20px;
    margin-bottom: 20px;    
  }
  .loading-box{
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: var(--smtc-color-primary);
    i{
        font-size: 20px;
    }
    p{
        margin-top: 12px;
    }
  }
  .chart-series{
    display: flex;
    justify-content: left;
    margin:16px 0;
    li{
        padding: 4px 10px;
        border: 1px solid #DCDFE6;
        margin-right: 16px;
        border-radius: 3px;
        cursor: pointer;
    }
    .active{
        background-color: var(--smtc-color-primary);
        color: #fff;
        border: 1px solid var(--smtc-color-primary);
    }
  }
</style>
